var render, staticRenderFns
import script from "./chat-message.vue?vue&type=script&lang=js"
export * from "./chat-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03eff956')) {
      api.createRecord('03eff956', component.options)
    } else {
      api.reload('03eff956', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/chat/messages/chat-message.vue"
export default component.exports